import { Stack, useMediaQuery, useTheme } from '@mui/material';
import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';

interface SuccessAlertProps {
  message: string
}

export default function SuccessAlert({ message }: SuccessAlertProps) {
  const theme = useTheme();
  const currentTheme = theme.palette.mode;  
  const isTablet = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <Stack
      sx={{
        '& .css-1k9glbq-MuiPaper-root-MuiAlert-root': {
          color: currentTheme === 'light' ? 'rgb(0, 63, 9)' : 'rgb(204, 232, 205);',
          backgroundColor: currentTheme === 'light' ? 'rgb(204, 232, 205)' : 'rgba(0, 63, 9, 0.63)',
          border: 'none',
        },
        '& .css-8hoymy-MuiSvgIcon-root': {
          color: currentTheme === 'light' ? 'rgb(0, 63, 9)' : 'rgb(204, 232, 205);',
        },
        width: '80%',
        position: 'fixed', // Mudado de 'absolute' para 'fixed'
        right: 0,
        top: isTablet ? 'unset' : '10px',
        bottom: isTablet ? '10px' : 'unset',
        transform: 'translateX(100%)', // Inicialmente fora da tela
        animation: 'slideIn 0.5s ease-out forwards, slideOut 0.5s ease-in 5s forwards',
        '@keyframes slideIn': {
          from: {
            transform: 'translateX(100%)',
            opacity: 0,   
          },
          to: {
            transform: 'translateX(0)',
            opacity: 1,
          },
        },
        '@keyframes slideOut': {
          from: {
            transform: 'translateX(0)',
            opacity: 1,
          },
          to: {
            transform: 'translateX(100%)',
            opacity: 0,
          },
        },
        '@media (min-width: 700px)': {
          width: '40%',
        },
        zIndex: '1000',
      }}
      spacing={2}
    >
      <Alert severity="success">
        <AlertTitle
          sx={{
            fontWeight: 'bold'
          }}
        >
          Sucesso!
        </AlertTitle>
        {message}
      </Alert>
    </Stack >
  )
}